export enum OutlinePanelOptions {
  Top = 'Top',
  Right = 'Right',
  Bottom = 'Bottom',
  Left = 'Left',
}

export const DEFAULT_OUTLINES = [OutlinePanelOptions.Top, OutlinePanelOptions.Bottom];
